/**
 * /tenants/$slug/agents/budget-raises — the approver's queue of temporary budget increases
 * awaiting a second administrator. Thin shim: mount the page (the query polls on its own).
 */

import { createFileRoute } from "@tanstack/react-router";
import { BudgetRaisesQueuePage } from "@/features/agents/pages/budget-raises-queue-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/budget-raises")({
  component: BudgetRaisesQueuePage,
});
